import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../api-base-url.token';

export interface PilotageEstablishment {
  establishmentId: string;
  name: string;
  sensorCount: number;
  totalInToday: number;
  totalOutToday: number;
  currentOccupancy: number;
  thresholdLow: number;
  thresholdHigh: number;
  queueId:   string | null;
  queueName: string | null;
  waitMinutes:   number | null;
  waitSource:       'MANUAL' | 'SENSOR' | 'AUTO' | 'BASELINE' | 'BASELINE_WIZARD' | null;
  waitExpiresAt:    string | null;
  isOpen:            boolean;
  timelineStatuses:  string[];
  timelineMinutes:   (number | null)[];
  timelineBaseTime:  string | null;
  todayHours:        string | null;
  latitude:          number | null;
  longitude:         number | null;
  timezone:          string;
}

@Injectable({ providedIn: 'root' })
export class PilotageService {
  private readonly http = inject(HttpClient);
  private readonly base = inject(API_BASE_URL).replace(/\/+$/, '');

  getEstablishments(): Observable<PilotageEstablishment[]> {
    return this.http.get<PilotageEstablishment[]>(`${this.base}/api/v1/pilotage/establishments`);
  }
}
